// extracted by mini-css-extract-plugin
module.exports = {"accordion":"CheckboxGroupFilter_accordion__Bmine","checkboxWrapper":"CheckboxGroupFilter_checkboxWrapper__3MYf4","titleWrapper":"CheckboxGroupFilter_titleWrapper__3q48Y"};